import useNamespacedStorage, { setNamespacedStorageItem } from '../../hooks/storage/useNamespacedStorage';

export default function useManuallyClosed() {
  return useNamespacedStorage('ostroManuallyClosed', false);
}

export function setManuallyClosed(value: boolean) {
  setNamespacedStorageItem('ostroManuallyClosed', value);
}
